import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import ReactDOM from 'react-dom';
import { withTranslation } from 'react-i18next';
var HeaderList = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(HeaderList, _React$PureComponent);
  var _super = _createSuper(HeaderList);
  function HeaderList(props) {
    var _this;
    _classCallCheck(this, HeaderList);
    _this = _super.call(this, props);
    _this.handleClick = function (event) {
      if (_this.props.disabled) return;
      var container = _this.getContainer();
      if (container.contains(event.target)) {
        _this.toggle();
      } else {
        if (_this.state.dropdownOpen) {
          _this.setState({
            dropdownOpen: !_this.state.dropdownOpen
          });
        }
      }
    };
    _this.toggle = function () {
      _this.setState({
        dropdownOpen: !_this.state.dropdownOpen
      });
    };
    _this.state = {
      dropdownOpen: false
    };
    return _this;
  }
  _createClass(HeaderList, [{
    key: "getContainer",
    value: function getContainer() {
      return ReactDOM.findDOMNode(this);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('click', this.handleClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleClick);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      /*
      *  here need to use click event in DropdownItem instead of onMouseDown, reactStrap listen click, keyUp, to trigger toggle function,
      *  if we listen mouseDown event the tool bar will render,the position of the component will change
      *  and then the click event of this component will not be triggered
      * */
      return /*#__PURE__*/React.createElement("div", {
        className: 'header-list'
      }, /*#__PURE__*/React.createElement("div", {
        className: 'list-body ' + (this.props.disabled ? '' : 'header-list-body-hover') + (this.state.dropdownOpen ? ' header-list-body-highlight' : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: 'list-title'
      }, this.props.t(this.props.headerType)), /*#__PURE__*/React.createElement("div", {
        className: 'list-caret'
      }, /*#__PURE__*/React.createElement("i", {
        className: this.state.dropdownOpen ? 'iconfont icon-caret-up' : 'iconfont icon-drop-down'
      }))), this.state.dropdownOpen && /*#__PURE__*/React.createElement("div", {
        className: 'list-dropdown'
      }, /*#__PURE__*/React.createElement("div", {
        className: 'list-dropdown-item',
        onClick: function onClick(event) {
          _this2.props.onClickHeader(event, 'paragraph');
        }
      }, this.props.t('paragraph')), /*#__PURE__*/React.createElement("div", {
        className: 'list-dropdown-item',
        onClick: function onClick(event) {
          _this2.props.onClickHeader(event, 'header_one');
        }
      }, this.props.t('header_one')), /*#__PURE__*/React.createElement("div", {
        className: 'list-dropdown-item',
        onClick: function onClick(event) {
          _this2.props.onClickHeader(event, 'header_two');
        }
      }, this.props.t('header_two')), /*#__PURE__*/React.createElement("div", {
        className: 'list-dropdown-item',
        onClick: function onClick(event) {
          _this2.props.onClickHeader(event, 'header_three');
        }
      }, this.props.t('header_three')), /*#__PURE__*/React.createElement("div", {
        className: 'list-dropdown-item',
        onClick: function onClick(event) {
          _this2.props.onClickHeader(event, 'header_four');
        }
      }, this.props.t('header_four')), /*#__PURE__*/React.createElement("div", {
        className: 'list-dropdown-item',
        onClick: function onClick(event) {
          _this2.props.onClickHeader(event, 'header_five');
        }
      }, this.props.t('header_five')), /*#__PURE__*/React.createElement("div", {
        className: 'list-dropdown-item',
        onClick: function onClick(event) {
          _this2.props.onClickHeader(event, 'header_six');
        }
      }, this.props.t('header_six'))));
    }
  }]);
  return HeaderList;
}(React.PureComponent);
export default withTranslation('seafile-editor')(HeaderList);